import type { ClientWithLanding } from '@/landing/resolve-landing'
import { resolveLanding } from '@/landing/resolve-landing'

export type MarketingShellChrome = {
  signInLabel: string
  registerLabel: string
  hideRegister: boolean
  hideSignIn: boolean
  stickyOverlayHeader: boolean
  stickyHeaderSolid: boolean
  stickyHeaderContentInset: boolean
  transparentShell: boolean
}

/** Header + shell props shared by marketing landing and public share pages. */
export function getMarketingShellChrome(client: ClientWithLanding): MarketingShellChrome {
  const resolved = resolveLanding(client)
  const overlayChrome =
    resolved.preset === 'splitHero' && resolved.splitHeroLayout.stickyChrome === 'overlay'

  return {
    signInLabel: resolved.headerAuth.signInLabel,
    registerLabel: resolved.headerAuth.registerLabel,
    hideRegister: resolved.headerAuth.hideRegister,
    hideSignIn: resolved.headerAuth.hideSignIn,
    stickyOverlayHeader: overlayChrome,
    stickyHeaderSolid: overlayChrome,
    stickyHeaderContentInset: overlayChrome,
    transparentShell: overlayChrome || resolved.transparentShell,
  }
}
